<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">复制人员组</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			pgroup_copy接口提供了复制人员组的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/pgroup_copy">https://skfrm.cn/APIV2/pgroup_copy</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-value :propsTableData='frmReturnvalue'></frm-Return-value>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnvalueTable';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,			
			'frm-Request-parameters':FrmRequestParamsTable,		
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable, 
		},
		data(){
			return{
				isPathData:['FRM API-v2','人员管理','复制人员组'],
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"当前项目id"},
					{"require":"是","name":"group_ids","type":"string","msg":"要复制的人员组id（可以多个，以逗号分隔）"},
					{"require":"是","name":"dst_group_id","type":"int","msg":"复制到该人员组id下"},
				],
				frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
				],
				frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"2001","errormessage":"目标人员组的子组数量超限","msg":"每个人员组的同级子组数量上限为100个"},
					{"Statuscode":"2002","errormessage":"目标人员组的子组层级超限","msg":"人员组层级上限为10层"},
					{"Statuscode":"3003","errormessage":"group_ids 或dst_group_id无效","msg":"人员组不存在"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Personnelmanagement/Replicatorgroup.vue